// @ts-ignore

import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import UFOSegment from '@atlaskit/react-ufo/segment';

import { wacToken } from '@/libraries/design/foundations';
import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { Row } from '@/libraries/wpl/foundations/src/grid';
import { LogoV3 } from '@/libraries/wpl/foundations/src/logo-v3';
import { TryPageCard } from '@/templates/try/try-page/components/try-page-card';
import { TryPageHeader } from '@/templates/try/try-page/components/try-page-header';

import { messages } from '../messages';

const sectionCss = css({
	padding: '32px 0',
	position: 'relative',
	verticalAlign: 'baseline',
	marginInlineEnd: 'auto',
	marginInlineStart: 'auto',
	minWidth: '100%',
});

const CollaborateSection = () => {
	const intl = useIntl();

	const tryCloud = intl.formatMessage(messages.tryCloud);
	const collaborateTitle = intl.formatMessage({
		id: 'TryPageTemplate.collaborate.title',
		defaultMessage: 'Collaborate',
	});
	const confluenceBody = intl.formatMessage({
		id: 'TryPageTemplate.collaborate.confluenceBody',
		defaultMessage:
			'Get things done instead of hunting things down. Organize your work, create documents, and discuss everything in one place.',
	});

	const trelloBody = intl.formatMessage({
		id: 'TryPageTemplate.collaborate.trelloBody',
		defaultMessage:
			'Collaborate and get more done. Trello boards enable your team to organize projects in a fun, flexible, and visual way.',
	});

	const loomBody = intl.formatMessage({
		id: 'TryPageTemplate.collaborate.loomBody',
		defaultMessage:
			'Record your screen, camera, and voice with Loom. Send async video messages on an AI-powered platform.',
	});

	const confluenceLogo = <LogoV3 brand={'confluence'} type="logo" appearance="brand" />;

	const trelloLogo = <LogoV3 brand={'trello'} type="logo" appearance="brand" />;

	const loomLogo = <LogoV3 brand={'loom'} type="logo" appearance="brand" />;

	return (
		<UFOSegment css={sectionCss} name={'collaborateCards'}>
			<Row>
				<TryPageHeader
					headerText={collaborateTitle}
					dividerColor={wacToken('color.primary.blue')}
				/>
			</Row>
			<Row layout="6-6">
				<TryPageCard
					logo={confluenceLogo}
					link={useLocalizedHref('/software/confluence/free')}
					bodyText={confluenceBody}
					ctaText={tryCloud}
				/>
				<TryPageCard
					logo={trelloLogo}
					link={'https://www.trello.com/signup'}
					bodyText={trelloBody}
					ctaText={tryCloud}
				/>
			</Row>
			<div />
			<Row layout="6-6">
				<TryPageCard
					logo={loomLogo}
					link={useLocalizedHref('/try/cloud/signup?bundle=loom&edition=premium')}
					bodyText={loomBody}
					ctaText={tryCloud}
				/>
				<div />
			</Row>
		</UFOSegment>
	);
};

export default CollaborateSection;
